// ── 執行期設定：登入網址由伺服器依環境提供，不在 build 時寫死 ──────────────────

/** 取得主網域登入網址；失敗或格式不對回傳 null，由呼叫端決定如何呈現（不猜網域） */
export const fetchMainLoginUrl = async (): Promise<string | null> => {
  try {
    const res = await fetch('/api/client-config');
    if (!res.ok) return null;
    const body = (await res.json()) as { mainLoginUrl?: unknown };
    return typeof body.mainLoginUrl === 'string' && body.mainLoginUrl !== '' ? body.mainLoginUrl : null;
  } catch {
    return null;
  }
};
